import React from 'react';
import Icon from '../Icon';

/*eslint-disable */
const smiley = props => (
  <Icon viewBox="0 0 18 18" {...props}>
    <g>
      <title>smiley</title>
      <g fill="currentColor" fillRule="evenodd">
        <path d="M9 14.9a4.104 4.104 0 0 1-4.1-4.1h1c0 1.709 1.391 3.1 3.1 3.1s3.1-1.391 3.1-3.1h1c0 2.26-1.839 4.1-4.1 4.1M6.3 6.3a.9.9 0 1 1 0 1.8.9.9 0 0 1 0-1.8M11.7 6.3a.9.9 0 1 1 0 1.8.9.9 0 0 1 0-1.8"
        />
        <path d="M9 0a9 9 0 0 0-9 9 9 9 0 0 0 9 9 9 9 0 0 0 9-9 9 9 0 0 0-9-9m0 1c4.411 0 8 3.589 8 8s-3.589 8-8 8-8-3.589-8-8 3.589-8 8-8" />
      </g>
    </g>
  </Icon>
);
/*eslint-enable */

export default smiley;



// WEBPACK FOOTER //
// ./chat-app/svgIcons/components/smiley.js